import React, { Component } from "react";
import { Link } from "react-router-dom";
import { withRouter } from "react-router";
import { get, isNull, isUndefined } from "lodash";

import { withUnits } from "./../../../shared/containers/containerUnits";
import { withMainMap } from "./../../../shared/containers/containerMainMap";
import { withChoosedCar } from "./../../../shared/containers/containerChoosedCar";
import { withGeozones } from "../../../shared/containers/geozonesContainer";
import { withMapControl } from "../../../shared/containers/containerMapControl";
import { withRoutes } from "../../../shared/containers/containerRoutes";

import { states } from "../../../reducers/queriesStates";
import CheckCircleOutlineIcon from "@mui/icons-material/CheckCircleOutline";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";

import { getCarsTypeName } from "./static.carsTypes";
import CarsBookmark from "./carsBookmark";
import ControlCarListItem from "./controlCarListItem";
import Icon from "./../../../shared/items/static/icon";
import getDates from "./../../../shared/services/date.service";
import TooltipWrapper from "./../../../shared/items/contols/tooltipWrapper";
import SettingsIcon from "@mui/icons-material/Settings";
import styles from "./carsListItem.module.scss";
import { withCompanyGroups } from "../../../shared/containers/containerCompanyGroups";

const GPS_SIGNAL_ERROR = "Ошибка данных GPS";
const UNSET_BOOKMARK = "Убрать из Избранных";
const SET_BOOKMARK = "Добавить в Избранные";
const SET_CENTER_MAP = "Показать на карте";
const IS_CENTER_MAP = "Машина в центре карты";
const INTELLIGENCE = "Открыть Сведения";
const CAR_IS_CHOOSED = "Автомобиль уже выбран, выбрать текущий?";
const CLOSE_INTELLIGENCE = "Закрыть сведения";

class CarsListItem extends Component {
  constructor(props) {
    super(props);

    this.state = {
      isAddToGeozone: false,
    };

    this.isSelectedItem = this.isSelectedItem.bind(this);
  }

  componentDidMount() {
    const { handleScrollTo } = this.props;

    if (this.isOpenedItem() && document.querySelectorAll(`.opened_container_carsListItem`)[0])
      handleScrollTo(document.querySelectorAll(`.opened_container_carsListItem`)[0].offsetTop);
  }

  componentWillUnmount() {
    const { choosedCarId, data, onClearChoosedCar } = this.props;

    if (data.id === choosedCarId) onClearChoosedCar();
  }

  componentDidUpdate(prevProps) {
    const { data, choosedCarId, onSetCenterMap, geozoneAddUnitDataState, geozoneRemoveUnitDataState, selectGeozone } = this.props;

    //if unset as choosedCar
    if (get(prevProps, ["choosedCarId"], null) === data.id && choosedCarId !== data.id && !isNull(get(prevProps, ["choosedCarId"], null))) {
      onSetCenterMap(get(data, ["lastLocation", "lat"], ""), get(data, ["lastLocation", "long"], ""));
    }

    if ((prevProps.selectGeozone === null && selectGeozone !== null) || (prevProps.selectGeozone !== null && selectGeozone === null)) {
      this.setState({
        isAddToGeozone: this.geozoneIsAdded(selectGeozone === null ? [] : selectGeozone.units, data.id),
      });
    }

    if (prevProps.selectGeozone !== null && selectGeozone !== null) {
      if (prevProps.selectGeozone.id !== selectGeozone.id) {
        this.setState({ isAddToGeozone: this.geozoneIsAdded(selectGeozone.units, data.id) });
      }
    }

    if (
      (geozoneAddUnitDataState === states.READY && prevProps.geozoneAddUnitDataState === states.REQUEST) ||
      (geozoneRemoveUnitDataState === states.READY && prevProps.geozoneRemoveUnitDataState === states.REQUEST)
    ) {
      this.setState({ isAddToGeozone: this.geozoneIsAdded(selectGeozone.units, data.id) });
    }
  }

  isSelectedItem() {
    const { choosedCarId, data } = this.props;

    return choosedCarId === data.id;
  }

  isOpenedItem() {
    const { match, data } = this.props;

    return match.params.id === data.id;
  }

  isDefauleItem() {
    return !this.isSelectedItem() && !this.isOpenedItem();
  }

  сontrolCarListItemClickHandler() {
    const { data, onChooseCar, onSetMapCenter, match, choosedCarId, zoom, onSetZoom } = this.props;
    const path = match.path;

    onSetMapCenter({ lat: data.lastLocation.lat, lng: data.lastLocation.long });
/*     onSetZoom(15); */

    if ((!this.isSelectedItem() && path !== "/") || (path !== "/cars" && isNull(choosedCarId))) {
      onSetMapCenter.bind(this, { lat: data.lastLocation.lat, lng: data.lastLocation.long });
    } else if (!isNull(choosedCarId) && !this.isSelectedItem()) {
      onChooseCar.bind(this, data);
    }
  }

  geozoneIsAdded(units, unitId) {
    return units.some((x) => {
      return x !== undefined && x.id === unitId;
    });
  }

  addToGeozone() {
    const { data, selectGeozone, onAddUnitToGeozone } = this.props;
    onAddUnitToGeozone(selectGeozone.id, { id: data.id, title: "", registerNumber: data.unit.registerNumber });
  }

  deleteToGeozone() {
    const { data, selectGeozone, onDeleteUnitToGeozone } = this.props;
    onDeleteUnitToGeozone(selectGeozone.id, { id: data.id, title: "", registerNumber: data.unit.registerNumber });
  }

  addToGroup() {
    const { data, selectedGroup, onAddUnitGroup } = this.props;
    onAddUnitGroup(selectedGroup.id, { ...data.unit, id: data.id });
  }

  deleteToGroup() {
    const { data, selectedGroup, onDeleteUnitGroup } = this.props;
    onDeleteUnitGroup(selectedGroup.id, { ...data.unit, id: data.id });
  }

  getClassWrapper() {
    const { selectedTripId } = this.props;

    if (this.isAddMode() || selectedTripId !== null) {
      return styles.carsListItemWrapperSelectGeozone;
    }

    if (this.isOpenedItem()) {
      return styles.carsListItemOpenedWrapper;
    }

    if (this.isSelectedItem()) {
      return styles.carsListItemSelectedWrapper;
    }

    return styles.carsListItemWrapper;
  }

  onAddHandle() {
    const { selectGeozone, selectedGroup } = this.props;

    if (selectGeozone) {
      return this.addToGeozone.bind(this);
    }

    if (selectedGroup) {
      return this.addToGroup.bind(this);
    }

    return () => {};
  }

  onDeleteHandle() {
    const { selectGeozone, selectedGroup } = this.props;

    if (selectGeozone) {
      return this.deleteToGeozone.bind(this);
    }

    if (selectedGroup) {
      return this.deleteToGroup.bind(this);
    }

    return () => {};
  }

  isItemAdded() {
    const { selectGeozone, selectedGroup, data } = this.props;
    const { isAddToGeozone } = this.state;

    if (selectGeozone) {
      return selectGeozone.units.some((x) => {
        return x.id === data.id;
      });
    }

    if (
      selectedGroup !== null &&
      selectedGroup.units.some((x) => {
        return x.id === data.id;
      })
    ) {
      return true;
    }

    return false;
  }

  isAddMode() {
    const { selectGeozone, selectedGroup } = this.props;

    return !!selectGeozone || !!selectedGroup;
  }

  clickTripUnitHandle(data) {
    const {
      selectedTripUnitId,
      selectedTripId,
      selectedRouteId,
      onCreateTripUnit,
      onDeleteTripUnit,
      createTripUnitDataState,
      deleteTripUnitDataState,
    } = this.props;

    if (createTripUnitDataState !== states.REQUEST && deleteTripUnitDataState !== states.REQUEST) {
      const unit = { id: data.id, title: data.unit.title, registerNumber: data.unit.registerNumber };

      if (unit.id === selectedTripUnitId) {
        onDeleteTripUnit({ tripId: selectedTripId, unitId: unit.id }, selectedRouteId);
      } else {
        onCreateTripUnit({ tripId: selectedTripId, unitId: unit.id }, unit, selectedRouteId);
      }
    }
  }

  render() {
    const {
      data,
      onChooseCar,
      onClearChoosedCar,
      match,
      choosedCarId,
      selectedTripUnitId,
      selectedTripId,
      onSelectToChangeUnit,
    } = this.props;

    const path = match.path;
    const classWrapper = this.getClassWrapper();

    const getStatusStyles = () => {
      switch (data.unit.inActive ? "inActive" : getCarsTypeName(data.status.id)) {
        case "noData":
          return styles.container_carNumber_noData;
        case "inMove":
          return styles.container_carNumber_inMove;
        case "parking":
          return styles.container_carNumber_parking;
        case "inActive":
          return styles.container_carNumber_inActive;
        default:
          return null;
      }
    };

    const onAddHandle = this.onAddHandle();
    const onDeleteHandle = this.onDeleteHandle();

    return (
      <div className={classWrapper}>
        <div className={styles.container_carsListItemWrapper}>
          <div className={styles.carsListItem}>
            {!this.isOpenedItem() ? (
              <div
                className={styles.buttonSelectCar}
                onClick={this.isSelectedItem() ? onClearChoosedCar.bind(this, data) : onChooseCar.bind(this, data)}
              />
            ) : null}

            <TooltipWrapper title={data.status.title} position="right">
              <div className={getStatusStyles()}>
                <span className={styles.title}>{data.number}</span>
              </div>
            </TooltipWrapper>

            <div className={styles.carsListItemInner}>
              <div className={styles.container_carContent}>
                <div className={styles.container_name}>
                  <div>{data.unit.title}</div>

                  <div>{data.unit.registerNumber}</div>
                </div>
              </div>

              <div className={styles.container_params}>
                {!data.gpsSignal ? (
                  <div className={styles.container_gpsSignal}>
                    <TooltipWrapper title={GPS_SIGNAL_ERROR} position="top">
                      <div>
                        <Icon name="warning" />
                      </div>
                    </TooltipWrapper>
                  </div>
                ) : null}

                <div className={`${data.isBookmark ? styles.container_isBookmark : styles.container_bookmark}`}>
                  <TooltipWrapper title={data.isBookmark ? UNSET_BOOKMARK : SET_BOOKMARK} position="top">
                    <div>
                      <CarsBookmark carId={data.id} isBookmark={data.isBookmark} />
                    </div>
                  </TooltipWrapper>
                </div>

                {selectedTripId !== null ? (
                  <TooltipWrapper title={selectedTripUnitId === data.unit.id ? "Снять с маршрута" : "Назначит на маршрут"} position="top">
                    {selectedTripUnitId === data.id ? (
                      <div
                        className={styles.container_itemChecked}
                        onClick={() => {
                          this.clickTripUnitHandle(data);
                        }}
                      >
                        <CheckCircleIcon fontSize="small" />
                      </div>
                    ) : (
                      <div
                        className={styles.container_itemUnchecked}
                        onClick={() => {
                          this.clickTripUnitHandle(data);
                        }}
                      >
                        <CheckCircleOutlineIcon fontSize="small" />
                      </div>
                    )}
                  </TooltipWrapper>
                ) : null}

                {this.isAddMode() ? (
                  <div>
                    {this.isItemAdded() ? (
                      <TooltipWrapper title={`Открепить от ${data.unit.title} ${data.unit.registerNumber}`} position="top">
                        <div className={styles.container_itemChecked} onClick={onDeleteHandle}>
                          <CheckCircleIcon fontSize="small" />
                        </div>
                      </TooltipWrapper>
                    ) : (
                      <TooltipWrapper title={`Закрепить за ${data.unit.title} ${data.unit.registerNumber}`} position="top">
                        <div className={styles.container_itemUnchecked} onClick={onAddHandle}>
                          <CheckCircleOutlineIcon fontSize="small" />
                        </div>
                      </TooltipWrapper>
                    )}
                  </div>
                ) : null}
              </div>
            </div>
          </div>

          {this.isOpenedItem() && !this.isAddMode() ? (
            <TooltipWrapper title={CLOSE_INTELLIGENCE} position="top">
              <div className={styles.container_close}>
                <ControlCarListItem>
                  <Link to="/">
                    <Icon name="x" />
                  </Link>
                </ControlCarListItem>
              </div>
            </TooltipWrapper>
          ) : null}

          <div className={styles.container_controls}>
            <TooltipWrapper
              title={
                path === "/" || path === "/cars"
                  ? this.isSelectedItem()
                    ? IS_CENTER_MAP
                    : !isNull(choosedCarId)
                    ? CAR_IS_CHOOSED
                    : SET_CENTER_MAP
                  : ""
              }
              position="top"
            >
              <div className={styles.controlsItem}>
                <ControlCarListItem disabled={path !== "/" && path !== "/cars"} onClick={this.сontrolCarListItemClickHandler.bind(this)}>
                  <Icon name="map-icon" />
                </ControlCarListItem>
              </div>
            </TooltipWrapper>

            <TooltipWrapper title={INTELLIGENCE} position="top">
              <div
                className={styles.controlsItem}
                onClick={() => {
                  /*           onSetZoom(16);
                  onSetMapCenter({ lat: data.lastLocation.lat, lng: data.lastLocation.long }); */
                }}
              >
                <ControlCarListItem onClick={this.сontrolCarListItemClickHandler.bind(this)}>
                  <Link className={styles.linkWrapper} to={`/cars/${data.id}/intimerange`}>
                    <Icon name="Union" />
                  </Link>
                </ControlCarListItem>
              </div>
            </TooltipWrapper>
            <TooltipWrapper title={"Настройки ТС"} position="top">
              <div
                className={styles.controlsItem}
                onClick={() => {
                  onSelectToChangeUnit(data);
                }}
              >
                <ControlCarListItem>
                  <Link className={styles.linkWrapper} to={`/cars/${data.id}/settings`}>
                    <div style={{ paddingTop: "7px" }}>
                      <SettingsIcon fontSize="small" />
                    </div>
                  </Link>
                </ControlCarListItem>
              </div>
            </TooltipWrapper>
          </div>
        </div>

        {!this.isDefauleItem() ? (
          <div className={getStatusStyles(data.status.id)}>
            <div className={styles.mDCarItem}>
              <span className={styles.mDCarItemTitle}>IMEI</span>
              <span className={styles.mDCarItemContent}>{data.devices[0].imei}</span>
            </div>
            <div className={styles.mDCarItem}>
              <span className={styles.mDCarItemTitle}>Последняя активность</span>
              <span className={styles.mDCarItemContent}>{getDates.getDateFormat4(data.lastActive)}</span>
            </div>
            {data.unit.groups.length > 0 ? (
              <div className={styles.mDCarItem}>
                <span className={styles.mDCarItemTitle}>Группы</span>
                <span className={styles.mDCarItemContent}>
                  {data.unit.groups.map((item) => (
                    <div key={item.id}>{item.title}</div>
                  ))}
                </span>
              </div>
            ) : null}
          </div>
        ) : null}
      </div>
    );
  }
}

export default withRoutes(
  withCompanyGroups(withUnits(withGeozones(withChoosedCar(withMainMap(withMapControl(withRouter(React.memo(CarsListItem))))))))
);
